import React, { useEffect, useState } from "react";
import Footer from "../Layout/Footer";
import Header from "../Layout/Header";
import BackIcon from "../../common/images/back.svg";
import MyAccountSideBar from "./MyAccountSideBar";
import MyAccountProfile from "./MyAccountProfile";
import MyAccountWishList from "./MyAccountWishList";
import "./MyAccountMain.scss";
import { handleApiCall } from "../Helpers/apiHelper";
import cookie from "react-cookies";
import MyAccountSettings from "./MyAccountSettings";
import MyAccountBookings from "./MyAccountBookings";
import MyAccountCancellation from "./MyAccountCancellation";

const MyAccountMain = (props) => {
  const [activePage, setActivePage] = useState("");
  const [activeTab, setActiveTab] = useState("");
  const [customerDetails, setCustomerDetails] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [currentCurrency, setCurrentCurrency] = useState("SGD");
  const isMobile = window.innerWidth <= 480;
  const mobTitle = {
    dashboard: "My account",
    profile: "Profile",
    mytrips: "My trips",
    mybookings: "My bookings",
    cancellation: "Cancellation",
    settings: "Settings",
  };

  useEffect(() => {
    if (cookie.load("UserId")) {
      let params = "customer_id=" + cookie.load("UserId");
      handleGetCustomerDetails(params);
    }

    const { activePage, activeTab } = props.location.state;
    if (activePage) {
      setActivePage(activePage);
    }
    if (activeTab) {
      setActiveTab(activeTab);
    }
  }, []);

  const handleGetCustomerDetails = async (payLoad) => {
    try {
      setIsLoading(true);
      const response = await handleApiCall(
        "get",
        `customer/customerdetail?${payLoad}`
      );
      if (response.data.status === "ok") {
        const { result_set: customerDetails } = response.data;
        setCustomerDetails(customerDetails);
      }
    } catch (err) {
      console.error("Error fetching user details:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleHeaderNavigate = () => {
    setActivePage(isMobile ? "dashboard" : "profile");
  };

  const buttonLoader = (value) => {
    let btnType;
    if (value === "primary") {
      btnType = "--primary";
    } else if (value === "secondary") {
      btnType = "--secondary";
    } else if (value === "danger") {
      btnType = "--danger";
    } else {
      btnType = "";
    }
    return (
      <div class={`dot-loader loader${btnType}`}>
        <span></span>
        <span></span>
        <span></span>
      </div>
    );
  };

  return (
    <>
      <Header {...props} hideCurrencyFilter={true} />
      <section className="my-account-cntnr">
        {isMobile && (
          <div className="mob-page-title">
            {activePage !== "dashboard" && (
              <button
                onClick={handleHeaderNavigate}
                className="button button-fill"
              >
                <img src={BackIcon} alt="BackIcon" />
              </button>
            )}
            <h3>{mobTitle[activePage]}</h3>
          </div>
        )}
        <div className="my-account-row">
          {(!isMobile || activePage === "dashboard") && (
            <div className="my-account-col-lhs">
              <MyAccountSideBar
                activePage={activePage}
                setActivePage={setActivePage}
                customerDetails={customerDetails}
                handleGetCustomerDetails={handleGetCustomerDetails}
                isLoading={isLoading}
              />
            </div>
          )}
          <div className="my-account-col-rhs">
            {activePage === "profile" && (
              <MyAccountProfile setActivePage={setActivePage} />
            )}
            {activePage === "settings" && (
              <MyAccountSettings
                customerDetails={customerDetails}
                handleGetCustomerDetails={handleGetCustomerDetails}
                buttonLoader={buttonLoader}
              />
            )}
            {activePage === "mytrips" && (
              <MyAccountWishList isMobile={isMobile} />
            )}
            {activePage === "mybookings" && (
              <MyAccountBookings
                activeTab={activeTab}
                buttonLoader={buttonLoader}
              />
            )}
            {activePage === "cancellation" && (
              <MyAccountCancellation activeTab={activeTab} />
            )}
          </div>
        </div>
      </section>
      <Footer {...props} />
    </>
  );
};

export default MyAccountMain;
